<template>
    <div>
        <CompassTooltip
            :content="getExtensionOptionLabel()"
            :delay="{ show: 0, hide: 1 }"
            :disabled="disabled"
            placement="top"
        >
            <CompassIconButton
                ref="imageRichTextTrigger"
                :icon="getExtensionOptionIcon()"
                :disabled="disabled"
                :active="activeStyle(option) || isVisible"
                size="small"
                @click="updateVisibility(!isVisible)"
            />
        </CompassTooltip>

        <CompassPopover
            :isVisible="isVisible"
            :title="$t.__('richText.customoptions.ImageRichText.add_image')"
            customClass="image-richtext-popover"
            triggerRef="imageRichTextTrigger"
            @close="updateVisibility(false)"
        >
            <div class="image-richtext-popover__content">
                <CompassFormItem
                    :label="$t.__('richText.customoptions.ImageRichText.link')"
                    :error="inputError"
                    class="image-richtext-popover__form-item"
                >
                    <CompassInput
                        ref="imageRichtextInput"
                        v-model="imageSrc"
                        :isEraseable="true"
                        :error="!!inputError"
                        type="text"
                        class="image-richtext-popover__input"
                        @input="resetInputError"
                        @change="insertImage"
                    />
                </CompassFormItem>

                <div class="image-richtext-popover__buttons">
                    <CompassButton
                        :label="$t.__('common.actions.cancel')"
                        type="secondary"
                        size="small"
                        @click="updateVisibility(false)"
                    />
                    <CompassButton
                        :label="$t.__('common.actions.validate')"
                        :disabled="!!!imageSrc"
                        size="small"
                        @click="insertImage"
                    />
                </div>
            </div>
        </CompassPopover>
    </div>
</template>

<script>
import OptionsRichTextMixin from 'mixins/OptionsRichTextMixin';

export default {
    mixins: [OptionsRichTextMixin],
    data() {
        return {
            allowedImageTypes: [
                '.apng',
                '.gif',
                '.ico',
                '.jpg',
                '.jpeg',
                '.jfif',
                '.pjpeg',
                '.pjp',
                '.png',
                '.svg',
            ],
            isVisible: false,
            imageSrc: '',
            inputError: '',
        };
    },
    computed: {
        isValidExtension() {
            return this.allowedImageTypes.some((type) => {
                return this.imageSrc.toLowerCase().includes(type);
            });
        },
        isFromSellsy() {
            const currentSellsyFileHostname = window.location.hostname.replace(
                new RegExp('app|www'),
                'file',
            );
            return this.imageSrc.includes(currentSellsyFileHostname);
        },
    },
    methods: {
        getExtensionOptionLabel() {
            return this.$t.__(this.getExtensionOption(this.option).label);
        },
        getExtensionOptionIcon() {
            return this.getExtensionOption(this.option).icon;
        },
        updateVisibility(visible) {
            this.resetImageSrc();
            this.resetInputError();
            this.isVisible = visible;

            if (this.isVisible) {
                this.$nextTick(() => {
                    this.$refs.imageRichtextInput.$refs.compassInput.focus();
                });
            }
        },
        insertImage() {
            if (!this.validateImage()) {
                this.resetImageSrc();
                this.inputError = this.$t.__(
                    'richText.customoptions.ImageRichText.error_invalid_image',
                );
                return;
            }

            this.editor.commands.setImage({
                src: this.imageSrc.replace('http://', 'https://'),
            });
            this.editor.commands.focus();
            this.editor.commands.createParagraphNear();
            this.updateVisibility(false);
        },
        validateImage() {
            return this.isValidExtension || this.isFromSellsy;
        },
        resetInputError() {
            this.inputError = '';
        },
        resetImageSrc() {
            this.imageSrc = '';
        },
    },
};
</script>
<style lang="scss" scoped>
.image-richtext-popover {
    &__content {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-1);
    }

    &__input {
        min-width: 295px;
    }

    &__buttons {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: var(--spacing-0);
    }
}
</style>
